import format from "date-fns/format";

declare global {
    interface Date {
        GetLocalDateNoTimezone(): string;
    }
  }

Date.prototype.GetLocalDateNoTimezone = function(): string{
    return format(this, "yyyy-MM-dd'T'HH:mm:ss");
}